import {handleActions} from 'redux-actions';
import {Record, List} from 'immutable';

import {hasValue} from 'web-app/util/typescript';
import * as ConversationActions from 'web-app/react/inbox/conversation/actions';

import * as Actions from './actions';
import * as Constants from '../constants';

const State = Record({
    fetching: true,
    offset: 0,
    limit: 10,
    conversations: List(),
    isVisible: false,
    type: Constants.InboxTypes.OWN,
    archived: false,
    canFetchMoreInbox: true,
    conversationId: '',
});

export default handleActions(
    {
        [Actions.fetch.type]: state =>
            state.merge({
                fetching: true,
            }),
        [Actions.fetchFailed.type]: state =>
            state.merge({
                fetching: false,
            }),
        [Actions.fetchSuccess.type]: (state, {payload}) =>
            state.merge({
                fetching: false,
                offset: state.limit,
                conversations: List(payload.response),
                canFetchMoreInbox: payload.response.length >= state.limit,
            }),
        [Actions.fetchMore.type]: state =>
            state.merge({
                fetching: true,
            }),
        [Actions.fetchMoreFailed.type]: state =>
            state.merge({
                fetching: false,
            }),
        [Actions.fetchMoreSuccess.type]: (state, {payload}) =>
            state.merge({
                fetching: false,
                offset: state.offset + state.limit,
                conversations: state.conversations.concat(payload.response),
                canFetchMoreInbox: payload.response.length >= state.limit,
            }),
        [Actions.show.type]: state =>
            state.merge({
                isVisible: true,
            }),
        [Actions.hide.type]: state =>
            state.merge({
                isVisible: false,
            }),
        [Actions.setInboxType.type]: (state, {payload}) =>
            new State({
                type: payload.type !== undefined ? payload.type : state.type,
                archived: payload.archived !== undefined ? payload.archived : state.archived,
                conversationId: state.conversationId,
            }),
        [Actions.markConversationAsRead.type]: (state, {payload}) => {
            const conversationIndex = state.conversations.findIndex(c => c.conversationId === payload.conversationId);

            if (conversationIndex === -1) {
                return state;
            }

            const updatedConversations = state.conversations.update(conversationIndex, conversation => ({
                ...conversation,
                unread: false,
            }));

            return state.merge({
                conversations: updatedConversations,
            });
        },
        [Actions.updateAndBumpConversation.type]: (state, {payload}) => {
            return state.merge({
                conversations: updateConversationAndMoveToTop(state.conversations, payload.conversation),
            });
        },
        [ConversationActions.markAsUnreadSuccess.type]: (state, {payload}) => {
            const indexOfTarget = state.conversations.findIndex(conv => conv.conversationId === payload.conversationId);
            if (indexOfTarget > -1) {
                return state.merge({
                    conversations: state.conversations.update(indexOfTarget, conv => ({...conv, unread: true})),
                });
            }
            return state;
        },
        [ConversationActions.leaveConversationSuccess.type]: (state, {payload}) => {
            return state.merge({
                conversations: state.conversations.filter(
                    conversation => conversation.conversationId !== payload.conversationId,
                ),
            });
        },
        [ConversationActions.renameConversation.type]: (state, {payload}) => {
            return state.merge({
                conversations: state.conversations.map(conversation => {
                    if (conversation.conversationId === payload.conversationId) {
                        return {...conversation, title: payload.title};
                    } else {
                        return conversation;
                    }
                }),
            });
        },
    },
    new State(),
);

// Update a specific conversation in the conversation center
const updateConversationAndMoveToTop = (
    conversations /* : List<{conversationId: string; ...}>*/,
    updatedConversation /* : {conversationId: string; ...}*/,
) => {
    const indexOfExistingConversation = conversations.findIndex(
        conversation => conversation.conversationId === updatedConversation.conversationId,
    );
    if (hasValue(indexOfExistingConversation)) {
        return conversations.delete(indexOfExistingConversation).insert(0, updatedConversation);
    }
    return conversations.insert(0, updatedConversation);
};
